<template>
  <div class="html5-tutorial">
    <h1 class="htmlh1">HTML5の紹介</h1>
    <p>HTML5は、ウェブページを作成するための最新の標準マークアップ言語です。従来のHTMLに比べ、より強力で柔軟な機能が追加されました。</p>
    
    <section>
      <h2 class="htmlh2">1. HTML5とは？</h2>
      <p>HTML5は、Web技術の進化に対応するために開発された新しいバージョンのHTMLです。構造の明確化、マルチメディアの強化、APIの追加など、多くの改良が施されています。</p>
    </section>
    
    <section>
      <h2 class="htmlh2">2. HTMLの発展</h2>
      <p>HTMLは1990年代初頭に開発され、Webの普及と共に進化してきました。HTML4までは静的なページが主流でしたが、HTML5では動的でインタラクティブな機能が強化されています。</p>
    </section>
    
    <section>
      <h2 class="htmlh2">3. HTML4とHTML5の違い</h2>
      <ul>
        <li>新しいセマンティックタグ（&lt;header&gt;, &lt;section&gt;, &lt;article&gt; など）の追加</li>
        <li>&lt;audio&gt; や &lt;video&gt; タグによるマルチメディア対応</li>
        <li>ローカルストレージ（localStorage, sessionStorage）の導入</li>
        <li>Web API（Geolocation API, Canvas API など）の追加</li>
      </ul>
    </section>
    
    <section>
      <h2 class="htmlh2">4. HTML5のコア機能</h2>
      <p>HTML5では、次のようなコア機能が提供されています：</p>
      <ul>
        <li>よりセマンティックなマークアップ</li>
        <li>マルチメディアのネイティブサポート</li>
        <li>Webアプリケーション向けの新しいAPI</li>
        <li>オフライン機能とローカルストレージ</li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HTML5Introduction'
};
</script>

<style scoped>
  @import './HTMLCss.scss';
</style>
